import { useState } from 'react';
import { homeFaqs } from '../../../mocks/faqs';

export default function HomeFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-sand py-28 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white border border-sand-dark rounded-full px-4 py-1.5 mb-5">
            <i className="ri-question-answer-line text-oak text-sm" />
            <span className="font-sans text-xs text-charcoal/60 font-semibold uppercase tracking-wide">Voice Search Optimized</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-walnut font-bold mt-1">
            Frequently Asked Questions
          </h2>
          <p className="font-sans text-charcoal/55 mt-5 text-base">
            Real answers to real questions Maryland homeowners ask about hardwood flooring.
          </p>
        </div>

        <div className="space-y-3">
          {homeFaqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all ${
                open === i ? 'border-oak/40 bg-white' : 'border-sand-dark bg-white'
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer hover:bg-sand/50 transition-colors"
              >
                <span className={`font-sans text-base font-bold pr-4 leading-snug ${open === i ? 'text-oak' : 'text-walnut'}`}>
                  {faq.q}
                </span>
                <div className={`w-9 h-9 flex items-center justify-center rounded-xl flex-shrink-0 transition-colors ${
                  open === i ? 'bg-oak text-white' : 'bg-sand text-oak border border-sand-dark'
                }`}>
                  <i className={`text-sm transition-transform duration-200 ${open === i ? 'ri-subtract-line' : 'ri-add-line'}`} />
                </div>
              </button>
              {open === i && (
                <div className="px-7 pb-7">
                  <div className="h-px bg-sand-dark mb-5" />
                  <p className="font-sans text-sm text-charcoal/70 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Schema FAQ */}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: homeFaqs.map((f) => ({
            '@type': 'Question',
            name: f.q,
            acceptedAnswer: { '@type': 'Answer', text: f.a },
          })),
        })}} />

        <div className="mt-10 text-center">
          <p className="font-sans text-charcoal/55 text-sm mb-5">Have a question not listed here? Call us directly.</p>
          <a
            href="tel:+14105550192"
            className="inline-flex items-center gap-2.5 px-8 py-3.5 bg-walnut text-white rounded-xl font-sans text-sm font-bold hover:bg-walnut-dark transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-fill" /> Call (410) 555-0192
          </a>
        </div>
      </div>
    </section>
  );
}
